import { combineReducers } from 'redux';

import mailThreadMessages from './mailThreadMessages/reducer';
import mailThreads from './mailThreads/reducer';
import textEditing from './textEditing/reducer';
import paging from './paging/reducer';
import emojis from './emojis/reducer';

export default combineReducers({
  mailThreadMessages,
  mailThreads,
  textEditing,
  paging,
  emojis
});



/** WEBPACK FOOTER **
 ** ./src/members/state/mail/reducer.js
 **/